/* ============================================================
   SYSME LIFE — ULTRA CINEMATIC SCROLL THEME v2
   GSAP 3 + ScrollTrigger + 3D CSS + Magnetic buttons
   ============================================================ */
(function(){
'use strict';
var $=function(s,p){return (p||document).querySelector(s)};
var $$=function(s,p){return Array.from((p||document).querySelectorAll(s))};

/* ─── HEADER scroll ───────────────── */
var hdr=$('.site-header');
if(hdr)window.addEventListener('scroll',function(){hdr.classList.toggle('scrolled',scrollY>30)},{passive:true});

/* ─── MOBILE NAV ────────────────── */
var mBtn=$('#mobile-menu-btn'),mNav=$('#mobile-nav'),mClose=$('#mobile-nav-close');
if(mBtn&&mNav){
  mBtn.onclick=function(){mNav.classList.add('is-open');document.body.style.overflow='hidden'};
  function closeMob(){mNav.classList.remove('is-open');document.body.style.overflow=''}
  if(mClose)mClose.onclick=closeMob;
  mNav.addEventListener('click',function(e){if(e.target===mNav)closeMob()});
}
$$('.mobile-sub-toggle').forEach(function(b){
  b.onclick=function(){
    var sub=this.nextElementSibling;if(!sub)return;
    var open=sub.style.display==='block';
    sub.style.display=open?'none':'block';
    var ic=this.querySelector('.mobile-sub-icon');
    if(ic)ic.style.transform=open?'':'rotate(180deg)';
  };
});

/* ─── CART DRAWER ─────────────── */
var cO=$('#cart-overlay'),cD=$('#cart-drawer'),cClose=$('#cart-close'),cCont=$('#cart-continue-btn');
function openCart(){if(cO&&cD){cO.classList.add('is-open');cD.classList.add('is-open');document.body.style.overflow='hidden'}}
function closeCart(){if(cO&&cD){cO.classList.remove('is-open');cD.classList.remove('is-open');document.body.style.overflow=''}}
if(cClose)cClose.onclick=closeCart;
if(cO)cO.onclick=closeCart;
if(cCont)cCont.onclick=closeCart;
$$('.js-open-cart').forEach(function(el){el.addEventListener('click',function(e){e.preventDefault();openCart()})});

/* ─── BUY NOW → DIRECT CHECKOUT ───────── */
/* Bypasses any ambiguity with native form submit routing:
   adds the item to cart via AJAX, then sends the browser
   straight to /checkout instead of the cart drawer/page. */
$$('.js-buy-now').forEach(function(btn){
  btn.addEventListener('click', function(e){
    e.preventDefault();
    var form = this.closest('form');
    if(!form){ window.location.href='/checkout'; return; }
    var origHTML = this.innerHTML;
    this.disabled = true;
    this.innerHTML = '<i class="ti ti-loader-2"></i> Redirecting…';
    var fd = new FormData(form);
    fetch('/cart/add.js', { method:'POST', body: fd, headers:{ 'Accept':'application/json' } })
      .then(function(res){ if(!res.ok) throw new Error('add failed'); return res.json(); })
      .then(function(){ window.location.href='/checkout'; })
      .catch(function(){
        btn.disabled = false;
        btn.innerHTML = origHTML;
        form.submit();
      });
  });
});

/* ─── AJAX CART: remove & quantity change, live totals ──── */
/* Works for both the cart drawer and the full /cart page.
   Rows are matched by data-cart-key (the Shopify line item key). */
var DELIVERY_CENTS = 29000;

function formatMoney(cents){
  var amount = (cents/100).toFixed(2);
  var parts = amount.split('.');
  parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  return 'Rs.' + parts.join('.');
}

function updateGlobalCartUI(cart){
  var hb = document.getElementById('header-cart-badge');
  if(hb){
    hb.textContent = cart.item_count;
    hb.style.display = cart.item_count > 0 ? '' : 'none';
  }
  var mc = document.getElementById('mobile-nav-cart-count');
  if(mc) mc.textContent = cart.item_count;
  var dc = document.getElementById('cart-drawer-count');
  if(dc) dc.textContent = cart.item_count;
  var ds = document.getElementById('cart-drawer-subtotal');
  if(ds) ds.textContent = formatMoney(cart.total_price);
  var dt = document.getElementById('cart-drawer-total');
  if(dt) dt.textContent = formatMoney(cart.item_count > 0 ? cart.total_price + DELIVERY_CENTS : cart.total_price);
  var ps = document.getElementById('cart-page-subtotal');
  if(ps) ps.textContent = formatMoney(cart.total_price);
  var pt = document.getElementById('cart-page-total');
  if(pt) pt.textContent = formatMoney(cart.total_price + DELIVERY_CENTS);
}

function removeCartRowFromDOM(key){
  document.querySelectorAll('[data-cart-key="'+key+'"]').forEach(function(row){
    if(row && row.parentNode) row.parentNode.removeChild(row);
  });
}

function cartChangeLine(key, quantity, rowEls){
  rowEls.forEach(function(r){ if(r&&r.classList) r.classList.add('is-updating'); });
  fetch('/cart/change.js', {
    method:'POST',
    headers:{'Content-Type':'application/json','Accept':'application/json'},
    body: JSON.stringify({ id: key, quantity: quantity })
  })
  .then(function(res){ return res.json(); })
  .then(function(cart){
    updateGlobalCartUI(cart);
    var item = null;
    for(var i=0;i<cart.items.length;i++){ if(cart.items[i].key===key){ item=cart.items[i]; break; } }
    if(!item || quantity === 0){
      removeCartRowFromDOM(key);
      if(cart.item_count === 0){ window.location.reload(); }
    } else {
      document.querySelectorAll('[data-cart-key="'+key+'"] .js-line-price').forEach(function(el){
        el.textContent = formatMoney(item.line_price);
      });
      document.querySelectorAll('[data-cart-key="'+key+'"] .qty-input').forEach(function(el){
        el.value = item.quantity;
      });
    }
    rowEls.forEach(function(r){ if(r&&r.classList) r.classList.remove('is-updating'); });
  })
  .catch(function(){
    rowEls.forEach(function(r){ if(r&&r.classList) r.classList.remove('is-updating'); });
    window.location.reload();
  });
}

document.addEventListener('click', function(e){
  var removeBtn = e.target.closest('.js-cart-remove');
  if(removeBtn){
    e.preventDefault();
    var rkey = removeBtn.dataset.cartKey;
    if(!rkey) return;
    var rrows = Array.prototype.slice.call(document.querySelectorAll('[data-cart-key="'+rkey+'"]'));
    cartChangeLine(rkey, 0, rrows);
  }
});

/* ─── QTY BUTTONS ─────────────── */
document.addEventListener('click',function(e){
  var b=e.target.closest('.qty-btn');if(!b)return;
  var key=b.dataset.cartKey;
  if(key){
    var wrap=b.closest('[data-cart-key]');
    var input=wrap?wrap.querySelector('.qty-input'):null;
    if(!input)return;
    var v2=parseInt(input.value)||1;
    if(b.dataset.action==='plus')v2=v2+1;
    if(b.dataset.action==='minus'&&v2>1)v2=v2-1;
    if(b.dataset.action==='minus'&&v2<=1){
      /* let it hit 0 via minus only if already at 1 and they want to remove — keep min 1 via UI, use trash icon to remove */
      v2=1;
    }
    input.value=v2;
    var rows=Array.prototype.slice.call(document.querySelectorAll('[data-cart-key="'+key+'"]'));
    cartChangeLine(key, v2, rows);
    return;
  }
  var inp=b.parentNode.querySelector('.qty-input');if(!inp)return;
  var v=parseInt(inp.value)||1;
  if(b.dataset.action==='plus')inp.value=v+1;
  if(b.dataset.action==='minus'&&v>1)inp.value=v-1;
});

document.addEventListener('change', function(e){
  var input = e.target.closest('.qty-input[data-cart-key]');
  if(!input) return;
  var v = Math.max(1, parseInt(input.value) || 1);
  input.value = v;
  var key = input.dataset.cartKey;
  var rows = Array.prototype.slice.call(document.querySelectorAll('[data-cart-key="'+key+'"]'));
  cartChangeLine(key, v, rows);
});

document.addEventListener('DOMContentLoaded', function(){

  /* Sticky ATC */
  var sAtc=$('#pp-sticky-atc'),origCta=$('.pp-cta-group');
  if(sAtc&&origCta&&'IntersectionObserver' in window){
    new IntersectionObserver(function(e){sAtc.classList.toggle('is-visible',!e[0].isIntersecting)},{threshold:0}).observe(origCta);
  }

  /* Scarcity bar */
  var fill=$('.pp-scarcity__fill');
  if(fill){var tw=fill.style.width;fill.style.width='0';setTimeout(function(){fill.style.width=tw},600)}

  /* ATC flash */
  $$('.pp-btn-atc').forEach(function(btn){
    btn.onclick=function(){
      if(this.disabled)return;
      var orig=this.innerHTML;this.innerHTML='<i class="ti ti-check"></i><span>Added!</span>';
      var s=this;setTimeout(function(){s.innerHTML=orig},1800);
    };
  });

  /* Reviews collapse (mobile) */
  var revBtn=document.getElementById('pp-reviews-toggle');
  var revGrid=document.getElementById('pp-reviews-grid');
  if(revBtn&&revGrid){
    revBtn.addEventListener('click',function(){
      var expanded=revGrid.classList.toggle('is-expanded');
      revBtn.classList.toggle('is-expanded',expanded);
      var txt=revBtn.querySelector('.pp-reviews-toggle-text');
      if(txt)txt.textContent=expanded?'Show Less':'Show All Reviews';
    });
  }

  /* ─── HORIZONTAL SCROLL DRAG ───────── */
  var track=$('#hscroll-track');
  if(track){
    var isDown=false,startX=0,scrollLeft=0;
    track.addEventListener('mousedown',function(e){isDown=true;track.classList.add('is-dragging');startX=e.pageX-track.offsetLeft;scrollLeft=track.scrollLeft});
    track.addEventListener('mouseleave',function(){isDown=false;track.classList.remove('is-dragging')});
    track.addEventListener('mouseup',function(){isDown=false;track.classList.remove('is-dragging')});
    track.addEventListener('mousemove',function(e){if(!isDown)return;e.preventDefault();var x=e.pageX-track.offsetLeft;track.scrollLeft=scrollLeft-(x-startX)*1.4});
    var hPrev=$('#hs-prev'),hNext=$('#hs-next');
    if(hPrev)hPrev.onclick=function(){track.scrollBy({left:-280,behavior:'smooth'})};
    if(hNext)hNext.onclick=function(){track.scrollBy({left:280,behavior:'smooth'})};
    var tStartX=0,tScrollLeft=0;
    track.addEventListener('touchstart',function(e){tStartX=e.touches[0].clientX;tScrollLeft=track.scrollLeft},{passive:true});
    track.addEventListener('touchmove',function(e){var dx=tStartX-e.touches[0].clientX;track.scrollLeft=tScrollLeft+dx},{passive:true});
  }

  /* ─── 3D TILT on any [data-tilt] ──────── */
  $$('[data-tilt],.pp-gallery__main,#tilt-card,.feat-banner').forEach(function(el){
    if(!window.matchMedia('(hover:hover)').matches)return;
    el.addEventListener('mousemove',function(e){
      var r=this.getBoundingClientRect();
      var x=((e.clientX-r.left)/r.width-.5)*18;
      var y=((e.clientY-r.top)/r.height-.5)*(-12);
      this.style.transform='perspective(900px) rotateY('+x+'deg) rotateX('+y+'deg) scale(1.02)';
      this.style.transition='none';
    });
    el.addEventListener('mouseleave',function(){
      this.style.transform='perspective(900px) rotateY(0deg) rotateX(0deg) scale(1)';
      this.style.transition='transform .6s cubic-bezier(.16,1,.3,1)';
    });
  });

  /* ─── 3D ORBIT mouse parallax ───────── */
  var orbit=$('#hero-orbit');
  if(orbit){
    var ox=0,oy=0,cx=0,cy=0;
    document.addEventListener('mousemove',function(e){
      ox=(e.clientX/window.innerWidth-.5)*24;
      oy=(e.clientY/window.innerHeight-.5)*(-14);
    });
    (function tick(){
      cx+=(ox-cx)*.05;cy+=(oy-cy)*.05;
      orbit.style.transform='rotateY('+cx+'deg) rotateX('+(12+cy)+'deg)';
      requestAnimationFrame(tick);
    })();
  }

  /* ─── GSAP SCROLL ANIMATIONS ─────── */
  if(window.gsap&&window.ScrollTrigger){
    gsap.registerPlugin(ScrollTrigger);

    /* ── HERO entrance ── */
    var heroText=$('#hero-text');
    if(heroText){
      var heroEls=$$('*',heroText).filter(function(el){return el.parentNode===heroText});
      if(!heroEls.length)heroEls=[heroText];
      gsap.set(heroText,{opacity:1});
      gsap.fromTo(heroText.children,
        {opacity:0,y:60,filter:'blur(8px)'},
        {opacity:1,y:0,filter:'blur(0px)',duration:1.2,stagger:.15,ease:'power3.out',delay:.2}
      );
    }
    var scene=$('#hero-scene');
    if(scene){
      gsap.fromTo(scene,
        {opacity:0,scale:.75,rotateY:25},
        {opacity:1,scale:1,rotateY:0,duration:1.6,ease:'power3.out',delay:.5}
      );
    }
    /* Hero chips stagger */
    gsap.fromTo($$('.hero__chip'),
      {opacity:0,scale:.7,y:20},
      {opacity:1,scale:1,y:0,duration:.8,stagger:.15,ease:'back.out(1.7)',delay:1}
    );

    /* ── TRUST BAR slide up ── */
    var trustBar=$('#trust-bar');
    if(trustBar){
      gsap.fromTo(trustBar,
        {opacity:0,y:40},
        {opacity:1,y:0,duration:.9,ease:'power2.out',
          scrollTrigger:{trigger:trustBar,start:'top 90%',once:true}}
      );
    }

    /* ── SECTION headings split reveal ── */
    $$('[data-anim="fade-up"]').forEach(function(el){
      gsap.fromTo(el,
        {opacity:0,y:50},
        {opacity:1,y:0,duration:1.1,ease:'power3.out',
          scrollTrigger:{trigger:el,start:'top 85%',once:true}}
      );
    });

    /* ── STAGGER CARDS with 3D ── */
    /* Group cards by parent so each group staggers independently */
    var cardGroups={};
    $$('[data-anim="stagger"]').forEach(function(el){
      var key=el.parentNode;
      if(!cardGroups[key]){cardGroups[key]=[];}
      cardGroups[key].push(el);
    });
    Object.values(cardGroups).forEach(function(cards){
      gsap.fromTo(cards,
        {opacity:0,y:60,rotateX:12,scale:.94},
        {opacity:1,y:0,rotateX:0,scale:1,
          duration:.9,stagger:.1,ease:'power3.out',
          scrollTrigger:{trigger:cards[0],start:'top 88%',once:true}}
      );
    });

    /* ── FADE FROM LEFT/RIGHT ── */
    $$('[data-anim="fade-from-left"]').forEach(function(el){
      gsap.fromTo(el,
        {opacity:0,x:-80,filter:'blur(4px)'},
        {opacity:1,x:0,filter:'blur(0px)',duration:1.2,ease:'power3.out',
          scrollTrigger:{trigger:el,start:'top 82%',once:true}}
      );
    });
    $$('[data-anim="fade-from-right"]').forEach(function(el){
      gsap.fromTo(el,
        {opacity:0,x:80,filter:'blur(4px)'},
        {opacity:1,x:0,filter:'blur(0px)',duration:1.2,ease:'power3.out',
          scrollTrigger:{trigger:el,start:'top 82%',once:true}}
      );
    });
    $$('[data-anim="fade-in"]').forEach(function(el){
      gsap.fromTo(el,
        {opacity:0},
        {opacity:1,duration:1,ease:'power2.out',
          scrollTrigger:{trigger:el,start:'top 85%',once:true}}
      );
    });

    /* ── CONCERN TAGS spring bounce ── */
    var tagWrap=$('#concern-tags');
    if(tagWrap){
      gsap.fromTo($$('.concern-tag',tagWrap),
        {opacity:0,scale:.75,y:24},
        {opacity:1,scale:1,y:0,duration:.6,stagger:.04,ease:'back.out(1.8)',
          scrollTrigger:{trigger:tagWrap,start:'top 85%',once:true}}
      );
    }

    /* ── BANNER PARALLAX (scrub) ── */
    $$('.feat-banner__bg').forEach(function(img){
      gsap.fromTo(img,
        {yPercent:-8},
        {yPercent:8,ease:'none',
          scrollTrigger:{trigger:img.closest('.feat-banner'),start:'top bottom',end:'bottom top',scrub:2}}
      );
    });

    /* ── STATS COUNTER ── */
    $$('.stats-band__num[data-count]').forEach(function(el){
      var target=parseInt(el.dataset.count)||0;
      var obj={val:0};
      gsap.to(obj,{val:target,duration:2.6,ease:'power2.out',
        scrollTrigger:{trigger:el,start:'top 85%',once:true},
        onUpdate:function(){el.textContent=(target>=1000?Math.round(obj.val).toLocaleString()+'+':Math.round(obj.val))}
      });
    });

    /* ── ABOUT US specific animations ── */
    $$('.au-stat').forEach(function(el,i){
      gsap.fromTo(el,
        {opacity:0,y:30,scale:.9},
        {opacity:1,y:0,scale:1,duration:.7,ease:'back.out(1.5)',delay:i*.1,
          scrollTrigger:{trigger:el,start:'top 90%',once:true}}
      );
    });
    $$('.au-cert').forEach(function(el,i){
      gsap.fromTo(el,
        {opacity:0,y:40,rotateY:20},
        {opacity:1,y:0,rotateY:0,duration:.9,ease:'power3.out',delay:(i%3)*.12,
          scrollTrigger:{trigger:el,start:'top 88%',once:true}}
      );
    });
    $$('.au-step').forEach(function(el,i){
      gsap.fromTo(el,
        {opacity:0,y:50,scale:.92},
        {opacity:1,y:0,scale:1,duration:.85,ease:'power3.out',delay:(i%3)*.1,
          scrollTrigger:{trigger:el,start:'top 88%',once:true}}
      );
    });
    $$('.au-promise-item').forEach(function(el,i){
      gsap.fromTo(el,
        {opacity:0,x:-30},
        {opacity:1,x:0,duration:.7,ease:'power2.out',delay:i*.1,
          scrollTrigger:{trigger:el,start:'top 88%',once:true}}
      );
    });

    /* ── CONTACT PAGE animations ── */
    $$('.cu-card').forEach(function(el,i){
      gsap.fromTo(el,
        {opacity:0,x:-40},
        {opacity:1,x:0,duration:.8,ease:'power3.out',delay:i*.1,
          scrollTrigger:{trigger:el,start:'top 88%',once:true}}
      );
    });
    var cuForm=$('.cu-form-card');
    if(cuForm){
      gsap.fromTo(cuForm,
        {opacity:0,x:60,scale:.96},
        {opacity:1,x:0,scale:1,duration:1.1,ease:'power3.out',
          scrollTrigger:{trigger:cuForm,start:'top 82%',once:true}}
      );
    }

    /* ── COLLECTION CARDS ── */
    $$('.col-card').forEach(function(el,i){
      gsap.fromTo(el,
        {opacity:0,y:50,scale:.9,rotateX:10},
        {opacity:1,y:0,scale:1,rotateX:0,duration:.85,stagger:.08,ease:'power3.out',delay:(i%3)*.1,
          scrollTrigger:{trigger:el,start:'top 88%',once:true}}
      );
    });

    /* ── PRODUCT CARDS hover 3D lift ── */
    $$('.prod-card,.why-card,.review-card').forEach(function(el,i){
      gsap.fromTo(el,
        {opacity:0,y:45,rotateX:8},
        {opacity:1,y:0,rotateX:0,duration:.9,ease:'power3.out',delay:(i%4)*.09,
          scrollTrigger:{trigger:el,start:'top 88%',once:true}}
      );
    });

    /* ── HORIZONTAL SCROLL slide in ── */
    var hs=$('#hscroll-track');
    if(hs){
      gsap.fromTo(hs,
        {opacity:0,x:80},
        {opacity:1,x:0,duration:1,ease:'power3.out',
          scrollTrigger:{trigger:hs,start:'top 85%',once:true}}
      );
    }

    /* ── FOOTER reveal ── */
    var footer=$('.site-footer');
    if(footer){
      gsap.fromTo(footer,
        {opacity:0,y:30},
        {opacity:1,y:0,duration:1,ease:'power2.out',
          scrollTrigger:{trigger:footer,start:'top 95%',once:true}}
      );
    }

    /* ── SCROLL PROGRESS BAR ── */
    var prog=document.createElement('div');
    prog.style.cssText='position:fixed;top:0;left:0;height:2.5px;background:linear-gradient(90deg,var(--or),var(--gold));z-index:9999;transform-origin:left;transform:scaleX(0);pointer-events:none;transition:none';
    document.body.appendChild(prog);
    ScrollTrigger.create({
      trigger:document.body,
      start:'top top',
      end:'bottom bottom',
      onUpdate:function(self){prog.style.transform='scaleX('+self.progress+')'}
    });

    /* ── PRODUCT IMAGE gallery 3D on scroll ── */
    var mainGallery=$('.pp-gallery__main');
    if(mainGallery){
      gsap.fromTo(mainGallery,
        {opacity:0,scale:.9,rotateY:-8},
        {opacity:1,scale:1,rotateY:0,duration:1.2,ease:'power3.out',delay:.1}
      );
    }

    /* ── SCARCITY bar on product page ── */
    var scBar=$('.pp-scarcity__fill');
    if(scBar){
      var tw2=scBar.style.width;scBar.style.width='0';
      gsap.to(scBar,{width:tw2,duration:1.8,ease:'power2.out',
        scrollTrigger:{trigger:scBar,start:'top 90%',once:true}});
    }

    /* ── TEXT SPLIT for section titles ── */
    $$('.section__title,.pin-section__title,.au-title').forEach(function(el){
      var html=el.innerHTML;
      /* Wrap non-em words in spans for stagger */
      el.style.overflow='hidden';
      gsap.fromTo(el,
        {opacity:0,y:30},
        {opacity:1,y:0,duration:.9,ease:'power3.out',
          scrollTrigger:{trigger:el,start:'top 88%',once:true}}
      );
    });

  } else {
    $$('[data-anim]').forEach(function(el){el.style.opacity='1';el.style.transform='none'});
  }

}); /* end DOMContentLoaded */

/* ─── CONTACT & ABOUT PAGE FAQs ─────── */
document.addEventListener('click',function(e){
  var btn=e.target.closest('.cu-faq-q');
  if(!btn)return;
  var open=btn.getAttribute('aria-expanded')==='true';
  $$('.cu-faq-q').forEach(function(b){b.setAttribute('aria-expanded','false');var a=b.nextElementSibling;if(a)a.classList.remove('is-open')});
  if(!open){btn.setAttribute('aria-expanded','true');var ans=btn.nextElementSibling;if(ans)ans.classList.add('is-open')}
});

})();
